import {
  handleAvailable,
  handleAvailableAddObject,
  handleRequest,
  handleUnavailable,
  handleUnavailableAddObject,
} from '../reducerHandlers';
import {
  SNACK_SET,
  STORE_AVAILABLE,
  STORE_AVAILABLE_OBJECT,
  STORE_REQUEST,
  STORE_UNAVAILABLE,
  STORE_UNAVAILABLE_OBJECT,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
};

export const reducer = createReducer(defaultState, {
  [STORE_REQUEST]: handleRequest,
  [STORE_AVAILABLE]: handleAvailable,
  [STORE_UNAVAILABLE]: handleUnavailable,
  [STORE_AVAILABLE_OBJECT]: handleAvailableAddObject,
  [STORE_UNAVAILABLE_OBJECT]: handleUnavailableAddObject,
});

export function getStoresUtcOffset({ store, coordinates }) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'storesUtcOffset'
    const loadingName = 'isLoadingStoresUtcOffset'
    dispatch({ type: STORE_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.getStoresUtcOffset(JSON.stringify(coordinates));
      const storeUtc = response?.store_utc_offset ?? undefined;
      dispatch({
        type: STORE_AVAILABLE_OBJECT,
        payload: { keyState: keyState, data: { [store]: storeUtc }, loadingName: loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: STORE_UNAVAILABLE_OBJECT,
        payload: { keyState: keyState, loadingName: loadingName, defaultState: {} },
      });
      const snack = {
        open: true,
        message: "There was an error getting the stores utc offset.",
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}